import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { getHRTheme } from './hrTheme';
import { useThemeMode } from '../context/ThemeModeContext';

const AppThemeProvider = ({ children }) => {
  const { mode } = useThemeMode(); // ✅ now SAFE
  const theme = React.useMemo(() => getHRTheme(mode), [mode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default AppThemeProvider;
